<template>
    <div>
        <div class="content">
            <el-row type="flex" align="bottom" style="width: 1200px;margin: auto;">
                <el-col :span="12" align="left" style="height: 150px;">
                    <div class="title">新闻动态</div>
                    <div class="text">了解中创远泰，了解行业前沿资讯</div>
                </el-col>
                <el-col :span="12" align="left">
                    <img class="img" src="../../assets/images/news.png"/>
                </el-col>
            </el-row>
        </div>
        <div class="detailsBox" v-loading="loading">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>新闻动态</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-menu
                        :default-active="defaultActive"
                        class="el-menu-vertical-demo"
                        background-color="#ffffff"
                        text-color="#303133"
                        active-text-color="#31b98b"
                        @select="handleSelect">
                        <el-menu-item v-for="(item, index) in categoryList" :key="index" :index="item.id.toString()">
                            <i class="el-icon-news"></i>
                            <span slot="title">{{item.name}}</span>
                        </el-menu-item>
                    </el-menu>
                </el-col>
                <el-col :span="20" style="margin-top: 30px;">
                    <div v-if="newsList.length > 0">
                        <el-card class="box-card" v-for="(item, index) in newsList" :key="index">
                            <div @click="skipLink(item.id)">
                                <el-row :gutter="60">
                                    <el-col :span="4">
                                        <div class="timeTitle">{{item.createTime ? item.createTime.substring(0, 7) : ''}}</div>
                                        <div class="timeText">{{item.createTime ? item.createTime.substring(8, 10) : ''}}</div>
                                    </el-col>
                                    <el-col :span="20">
                                        <div class="newsTitle">{{item.title}}</div>
                                        <div class="newsText">{{item.subtitle}}</div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-card>
                        <el-pagination
                            style="text-align: right; height: 50px;"
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="categoryList.currentPage"
                            :page-sizes="pageSizes"
                            :page-size="categoryList.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalPage">
                        </el-pagination>
                    </div>
                    <div v-else>
                        <el-card class="box-card">
                            <el-row align="middle">
                                <el-col :span="10" style="margin-top: 15%; text-align: center;">
                                    <h1>什么都没有找到</h1>
                                    <div>
                                        没有可以查看的动态信息！！！
                                    </div>
                                </el-col>
                                <el-col :span="14">
                                    <img src="../../assets/images/empty.gif">
                                </el-col>
                            </el-row>
                        </el-card>
                    </div>
                </el-col>
            </el-row>
        </div>

    </div>

</template>

<script>
import { getCategoryList, getNewsList } from '@/api/api'

export default {
    name: 'News',
    data () {
        return {
            loading: true,
            defaultActive: null,
            categoryList: [],
            newsList: [],
            currentPage: 1,
            pageSize: 10,
            totalPage: 1,
            pageSizes: [10, 20, 30],
            menuActiveKey: null
        }
    },
    created () {
        this.loading = true
        getCategoryList({categoryCode: 'XGXWDT-1'}).then(res => {
            if (res.data.success) {
                let result = res.data.result
                this.categoryList = result
                // console.log(this.categoryList[0].id)
                if (this.$route.params && this.$route.params.active) {
                    this.defaultActive = this.$route.params.active.toString()
                    this.menuActiveKey = this.$route.params.active.toString()
                    this.getNewsData(this.defaultActive)
                } else {
                    if (this.categoryList && this.categoryList[0].id) {
                        this.defaultActive = this.categoryList[0].id
                        this.menuActiveKey = this.categoryList[0].id
                        this.getNewsData(this.categoryList[0].id)
                    }
                }
                this.loading = false
            }
        })
    },
    methods: {
        skipLink (id) {
            this.$router.push({path: '/news-details', query: {id: id}})
        },
        handleSizeChange (val) {
            this.pageSize = val
            this.getNewsData(this.menuActiveKey)
        },
        handleCurrentChange (val) {
            this.currentPage = val
            this.getNewsData(this.menuActiveKey)
        },
        handleSelect (key, keyPath) {
            this.menuActiveKey = key
            this.currentPage = 1
            this.getNewsData(key)
        },
        getNewsData (id) {
            this.loading = true
            let params = {
                categoryId: id,
                pageNo: this.currentPage,
                pageSize: this.pageSize
            }
            getNewsList(params).then(res => {
                console.log(res)
                if (res.data && res.data.success) {
                    let result = res.data.result
                    this.newsList = result.records
                    this.currentPage = result.current
                    this.pageSize = result.size
                    this.totalPage = result.total
                }
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content{
    padding-top: 90px;
    background-color: #31b98b;
    .title{
        font-size: 36px;
        color: #ffffff;
        font-weight: bold;
        line-height: 40px;
        font-style: italic;
    }
    .text{
        font-size: 24px;
        color: #ffffff;
        line-height: 40px;
        margin-top: 20px;
        font-weight: 300;
    }
    .img{
        display: block;
        width: 500px;
    }
}
.detailsBox{
    width: 1200px;
    margin: auto;
    padding: 30px 0;
    .el-menu-vertical-demo{
        margin-top: 30px;
        text-align: left;
        .el-icon-menu{

        }
        .title{
            text-align: left;
        }
    }
    .box-card{
        box-shadow: none;
        margin-bottom: 20px;
        cursor: pointer;
        &:hover{
            box-shadow: 0px 3px 16px 5px rgba(0, 0, 0, 0.15);
            .newsTitle{
                color: #3ebe92;
            }
        }
        .timeTitle{
            background: #333333;
            color: #ffffff;
            height: 26px;
            line-height: 26px;
            font-size: 12px;
        }
        .timeText{
            color: #333333;
            height: 65px;
            line-height: 65px;
            font-size: 36px;
            border: 1px solid #ececec;
        }
        .newsTitle{
            text-align: left;
            width: 100%;
            font-size: 18px;
            font-weight: bold;
            color: #333333;
            height: 55px;
            line-height: 27px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .newsText{
            text-align: left;
            width: 100%;
            font-size: 14px;
            color: #797979;
            height: 45px;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/news/index.vue